export default "__VITE_ASSET__B15FoffZ__"